import { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useLibraryModel } from "../libraryModel";
import { ILibraryDetial } from "../libraryTypes";
import { getBaseImgLookUrl } from "@/utils/constants";
import { Image } from 'antd';
import { IFoodCategoryOotions } from "@/types/AppEnums";
import useNavModel from "@/model/navModel";
import moment from "moment";

export function DataTable() {
    const {
        dataSource, pgCfg, setMd5FormVal,
        loadData, setSelectedRowKeys, setSelectedRow, setIVisibleDrawer, removeDetail
    } = useLibraryModel();
    const { addNav, replaceNav } = useNavModel(() => []);
    const onEdit = (record: ILibraryDetial) => {
        console.log(record)
        setSelectedRow(record)
        setIVisibleDrawer("edit")
        setMd5FormVal(record.image ? [record.image] : [])
        setSelectedRowKeys([record.id as string])
    }
    const onRemove = (id: string) => {
        removeDetail(id)
    }
    const columns: ColumnsType<ILibraryDetial> = [
        {
            title: '序号',
            width: 80,
            align: "center",
            render: (text, record, index) => `${index + 1}`,
            fixed: "left"
        }, {
            title: '菜品图片',
            width: 130,
            dataIndex: 'image',
            render: (text: string, record: ILibraryDetial) => <Image width={60} src={getBaseImgLookUrl(text as string)} alt={record.name} />
        }, {
            title: '星级评分',
            width: 130,
            dataIndex: 'grade',
            render: (text, r) => <span style={{ color: "blue", cursor: "pointer" }} onClick={() => replaceNav("4-1", "4-1-1", { mode: "add", id: r.id as string }, true)}>{text}</span>
        }, {
            title: '菜品名称',
            width: 130,
            dataIndex: 'name',
        }, {
            title: '菜品标签',
            width: 130,
            dataIndex: 'labelName',
        }, {
            title: '菜品分类',
            width: 130,
            dataIndex: 'category',
            render: (text) => IFoodCategoryOotions.find(item => item.value === text)?.label
        }, {
            title: '最近评论时间',
            width: 130,
            dataIndex: "lastEvaluateTime",
            render: text => text ? moment(text).format("YYYY-MM-DD HH:mm:ss") : ""
        }, {
            title: '操作',
            width: 130,
            align: "center",
            dataIndex: 'phone',
            render: (text, record) => <div>
                <span className="click-span" onClick={() => onEdit(record)}>编辑</span>
                <span className="click-span" onClick={() => onRemove(record.id as string)}>删除</span>
            </div>
        }
    ];


    useEffect(() => {
        loadData()
    }, [])

    //点击行选高亮
    const onRow = (id: string) => {
        // if (selectedRowKeys.length > 0 && selectedRowKeys[0] === id) {
        //     setSelectedRowKeys([]);
        // } else {
        //     setSelectedRowKeys([id as string]);
        // }
    };

    return (
        <Table
            rowKey={record => record.id as string}
            // rowSelection={{
            //     type: "radio",
            //     selectedRowKeys: selectedRowKeys, //记录选中
            //     onChange: (selectedRowKeys: React.Key[], selectedRows: ILibraryDetial[]) => {
            //         setSelectedRowKeys(selectedRowKeys as string[]);
            //     }
            // }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id as string)
            })}
            scroll={{ x: 'max-content', y: 500 }}
        />
    )
}
